import { reactive } from "vue";
import i18n from "@/i18n";

// Typage de l'état réactif pour l'upload
interface FileUploadState {
  isModalActive: boolean;
  modalMessage: string;
  uploadProgress: number;
}
// Type du paramètre progress (ex: compatible avec axios, etc.)
interface UploadProgressEvent {
  percent: number;
}

export interface FileUpload {
  state: FileUploadState;
  cancelUpload(): void;
  continueNavigation(): void;
  startUpload(withUpload?: boolean, message?: string): void;
  onUploadProgress(progress: UploadProgressEvent): void;
  onUploadComplete(): void;
  finishUpload(): void;

}

export function useFileUpload(): FileUpload {
  const state = reactive<FileUploadState>({
    isModalActive: false,
    modalMessage: "",
    uploadProgress: 0,
  });

  const onUploadProgress = (progress: UploadProgressEvent): void => {
    state.uploadProgress = progress.percent * 100;
  };

  const onUploadComplete = (): void => {
    state.modalMessage = i18n.global.t("fileUpload.treatemntContinuing");
    state.uploadProgress = 100;
  };

  const startUpload = (
    withUpload: boolean = false,
    message: string = i18n.global.t("fileUpload.fileUploading"),
  ): void => {
    state.isModalActive = true;
    state.modalMessage = message;
    state.uploadProgress = 0;
    if (!withUpload) {
      onUploadComplete();
    }
  };

  const finishUpload = (): void => {
    state.isModalActive = false;
    state.uploadProgress = 0;
  };

  const cancelUpload = (): void => {
    // Logique pour annuler le chargement côté back-end
    finishUpload();
  };

  const continueNavigation = (): void => {
    finishUpload();
  };

  return {
    state,
    onUploadProgress,
    onUploadComplete,
    startUpload,
    finishUpload,
    cancelUpload,
    continueNavigation,
  };
}
